// eslint-disable-next-line
import { Drawer, Form, Select, Input } from 'antd';
import PropTypes from 'prop-types';
import { Box } from 'atoms';
import { ButtonWrapper } from 'components';
import { durationFilterOptions, alertStatusOptions } from './constants';

function FilterSection({
	open,
	setOpen,
	form,
	handleFilterSubmit,
	handleResetFilters,
	cities,
	statuses,
}) {
	return (
		<Drawer
			title="Filter Options"
			placement="right"
			width={400}
			onClose={() => setOpen(false)}
			open={open}
		>
			<Form
				form={form}
				layout="vertical"
				onFinish={handleFilterSubmit}
				style={{ paddingBottom: '64px' }}
			>
				<Form.Item name="city" label="City">
					<Select placeholder="Select City" showSearch allowClear options={cities} />
				</Form.Item>
				{/* <Form.Item name="min_temperature" label="Minimum Temperature (°C)">
					<Input type="number" placeholder="Enter minimum temperature" />
				</Form.Item>
				<Form.Item name="max_temperature" label="Maximum Temperature (°C)">
					<Input type="number" placeholder="Enter maximum temperature" />
				</Form.Item> */}
				<Form.Item name="time_filter" label="Time Duration">
					<Select
						placeholder="Select Time Duration"
						allowClear
						options={durationFilterOptions}
					/>
				</Form.Item>
				<Form.Item name="status" label="Status">
					<Select placeholder="Select Status" allowClear options={statuses} />
				</Form.Item>
				<Form.Item name="alert_status" label="Alert Status">
					<Select
						placeholder="Select Alert Status"
						allowClear
						options={alertStatusOptions}
					/>
				</Form.Item>
				<Box
					style={{
						width: '100%',
						position: 'absolute',
						bottom: 0,
						left: 0,
						display: 'flex',
						padding: '16px 24px',
						background: 'white',
						justifyContent: 'space-between',
						zIndex: 4,
						borderTop: '1px solid #f0f0f0',
					}}
				>
					<ButtonWrapper onClick={handleResetFilters}>RESET FILTERS</ButtonWrapper>
					<ButtonWrapper type="primary" onClick={() => form.submit()}>
						APPLY FILTERS
					</ButtonWrapper>
				</Box>
			</Form>
		</Drawer>
	);
}

FilterSection.propTypes = {
	open: PropTypes.bool.isRequired,
	setOpen: PropTypes.func.isRequired,
	form: PropTypes.object.isRequired,
	handleFilterSubmit: PropTypes.func.isRequired,
	handleResetFilters: PropTypes.func.isRequired,
	cities: PropTypes.array.isRequired,
	statuses: PropTypes.array.isRequired,
};

export default FilterSection;
